export default "__VITE_ASSET__DFST64QP__"